/**
 * SDS library page: filter pills + search (client-side).
 * Requires body[data-tc-sds-page] (set on page template suffix sds).
 */
(function () {
  'use strict';

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function parseWords(str) {
    var q = normalize(str);
    if (!q) return [];
    return q.split(/\s+/).filter(Boolean);
  }

  function bindSdsPage() {
    if (!document.body || !document.body.hasAttribute('data-tc-sds-page')) return;

    var searchInput = document.querySelector('.tc-sds-hero .tc-sds-search input');
    var searchBtn = document.querySelector('.tc-sds-hero .tc-sds-search button');
    var filterBar = document.querySelector('.tc-sds-filter');
    var tbody = document.querySelector('.tc-sds-table tbody');

    if (!tbody) return;

    var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr[data-tc-sds-row]'));
    if (!rows.length) return;

    var emptyRow = tbody.querySelector('tr[data-tc-sds-empty]');
    var countEl = document.querySelector('[data-tc-sds-visible-count]');
    var nounEl = document.querySelector('[data-tc-sds-result-noun]');

    var total = rows.length;
    var activeFilter = 'all';
    var searchQuery = '';
    var debounceTimer;

    var activePill = filterBar && filterBar.querySelector('.tc-filter-pill--active[data-tc-sds-filter]');
    if (activePill) {
      activeFilter = activePill.getAttribute('data-tc-sds-filter') || 'all';
    }

    function matchesSearch(row) {
      var words = parseWords(searchQuery);
      if (!words.length) return true;
      var hay = normalize(row.getAttribute('data-tc-sds-search-text'));
      return words.every(function (w) {
        return hay.indexOf(w) !== -1;
      });
    }

    function matchesFilter(row) {
      if (activeFilter === 'all') return true;
      var cat = row.getAttribute('data-tc-sds-category') || 'other';
      return cat === activeFilter;
    }

    function apply() {
      var visible = 0;
      rows.forEach(function (row) {
        var show = matchesFilter(row) && matchesSearch(row);
        row.hidden = !show;
        if (show) visible += 1;
      });

      if (countEl) countEl.textContent = String(visible);

      if (nounEl) {
        var sg = nounEl.getAttribute('data-singular') || 'product';
        var pl = nounEl.getAttribute('data-plural') || 'products';
        nounEl.textContent = visible === 1 ? sg : pl;
      }

      if (emptyRow) emptyRow.hidden = visible !== 0;

      try {
        var url = new URL(window.location.href);
        var trimmed = searchQuery.trim();
        if (trimmed) url.searchParams.set('q', trimmed);
        else url.searchParams.delete('q');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {
        /* ignore */
      }
    }

    function runSearchFromInput() {
      if (searchInput) searchQuery = searchInput.value;
      apply();
    }

    if (filterBar) {
      filterBar.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-tc-sds-filter]');
        if (!pill || !filterBar.contains(pill)) return;
        e.preventDefault();
        activeFilter = pill.getAttribute('data-tc-sds-filter') || 'all';
        var pills = filterBar.querySelectorAll('[data-tc-sds-filter]');
        pills.forEach(function (p) {
          p.classList.toggle('tc-filter-pill--active', p === pill);
        });
        apply();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          runSearchFromInput();
        }
      });
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runSearchFromInput, 220);
      });
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        runSearchFromInput();
      });
    }

    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (q && searchInput) {
        searchInput.value = q;
        searchQuery = q;
      }
    } catch (err) {
      /* ignore */
    }

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSdsPage);
  } else {
    bindSdsPage();
  }
})();
